<app-nav titulo="Inquilinos" descripcion="Aquí podrá ver, editar y borrar todos los inquilinos registrados en la plataforma, también puede regenerar sus credenciales.">
    <div class="tenants">
        <app-table-filter [filters]="filters" (values)="setFilterValues($event)"></app-table-filter>
        <app-data-table
            [rows]="tenants"
            [columns]="columns"
            [paginatorStatus]="paginatorStatus"
            [externalPagination]="true"
            (updateRows)="updateTenants($event)"
            (sortFn)="updateSort($event)"
        ></app-data-table>
    </div>
</app-nav>
<ng-template #buttonsColumnTemplate let-row="row">
    <div class="table-row-buttons">
        <button mat-icon-button matTooltip="Cambiar email" class="change-email-row-button" (click)="changeEmail(row)" *ngIf="userType === 'CORPORATIVO'">
            <mat-icon color="primary">alternate_email</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Restablecer contraseña" class="unlock-row-button" (click)="resetUserPassword(row)" *ngIf="userType === 'AGENTE' || userType === 'CORPORATIVO'">
            <mat-icon color="primary">lock_open</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Editar inquilino" class="edit-row-button" [routerLink]="'./' + row.id + '/editar'" *ngIf="userType === 'AGENTE' || userType === 'CORPORATIVO'">
            <mat-icon color="primary">edit</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Ver detalles" class="view-more-row-button" [routerLink]="'./' + row.id">
            <mat-icon color="primary">dehaze</mat-icon>
        </button>
    </div>
</ng-template>
